"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneBindingCache = cloneBindingCache;
function cloneBindingCache(cache) {
    if (cache.isRight) {
        return {
            isRight: true,
            value: cache.value,
        };
    }
    // A left cache is not cloned, just returned
    return cache;
}
//# sourceMappingURL=cloneBindingCache.js.map